// extracted by mini-css-extract-plugin
export default {"copy-custom":"CopyCustom_copy-custom__S6iP6"};